import React, { useState, useEffect } from 'react';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import { Gauge } from '@ant-design/plots';

const GuageForFix = () => {

    const [percentage, setPercentage] = useState() 

    useEffect(()=>{
        fetch(`${FetchVariable.Heroku}/vehicle/ratio-vehicle-guage`)
        .then((response) => response.json())
        .then((json) => {            
            setPercentage(json)
        })
        .catch((error) => {
          console.log('fetch data failed', error);
        });
    },[])

  const config = {
    percent: Number(percentage),
    radius: .80,
    range: {
      color: '#30BF78',
    },
    indicator: {
      pointer: {
        style: {
          stroke: '#black',
        },
      },
      pin: {
        style: {
          stroke: '#black',
        },
      },
    },
    axis: {
      label: {
        formatter(v) {
          return Number(v) * 100;
        },
      },
      subTickLine: {
        count: 3,
      },
    },
    statistic: {
      content: {
        formatter: ({ percent }) => `${(percent * 100).toFixed(2)}%`,
        style: {
          color: 'rgba(0,0,0,0.65)',
          fontSize: 24,
        },
      },
    },
  };
  return <Gauge {...config} />;
};

export default GuageForFix